(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BarcodeDetector", [], factory);
	else if(typeof exports === 'object')
		exports["BarcodeDetector"] = factory();
	else
		root["BarcodeDetector"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition